import type { Store } from '../../../store/list/types';
import { getPlaybacks } from './getPlaybacks';

/**
 * Start a new search.
 */
export const startSearch = (store: Store): void => {
  const { loaded, setSearching, setRecordings } = store.getState();
  // Prevents search from triggering while initial load hasn't completed.
  // Because we want to load more recordings when user has less than 300 on initial load.
  if (!loaded) {
    return;
  }

  setRecordings([]);
  setSearching(true);

  getPlaybacks(store);
};
